"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var AuthenticationCard_1 = __importDefault(require("@/Jetstream/AuthenticationCard"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
function VerifyEmail(_a) {
    var status = _a.status;
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({});
    var verificationLinkSent = status === 'verification-link-sent';
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('verification.send'));
    }
    return (react_1.default.createElement(AuthenticationCard_1.default, null,
        react_1.default.createElement(inertia_react_1.Head, { title: "Email Verification" }),
        react_1.default.createElement("div", { className: "mb-4 text-sm text-gray-600" }, "Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another."),
        verificationLinkSent && (react_1.default.createElement("div", { className: "mb-4 font-medium text-sm text-green-600" }, "A new verification link has been sent to the email address you provided during registration.")),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("div", { className: "mt-4 flex items-center justify-between" },
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)({ 'opacity-25': form.processing }), disabled: form.processing }, "Resend Verification Email"),
                react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('logout'), method: "post", as: "button", className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Log Out")))));
}
exports.default = VerifyEmail;
